import Swal from "sweetalert2";
import { addCoinsAPI } from "../services/userService";
import { fetchUserById } from "../../redux/user/userThunks";


/**
 * Opens a modal to add coins for a specific user.
 * @param {string} userId - ID of the user to add coins to
 * @param {function} onSuccess - callback when coins are successfully added
 */
export const openAddCoinsModal = async (userId, dispatch, navigate, onSuccess) => {

    const { value: formValues } = await Swal.fire({
        title: "Add Coins",
        html:
            `
        <div class="d-flex flex-column align-items-center gap-3">
                <input 
                    type="number" 
                    id="swal-amount" 
                    class="form-control form-control-sm w-75" 
                    placeholder="Enter number of coins" 
                    style="font-size:16px; border-radius:7px; padding:6px 12px;"
                    min="1"
                />
                <select 
                    id="swal-reason" 
                    class="form-select form-select-sm w-75" 
                    style="font-size:16px; border-radius:7px; padding:6px 12px;"
                >
                    <option value="" disabled selected>Select Reason</option>
                    <option value="Support">Support</option>
                    <option value="Bug Fix">Bug Fix</option>
                    <option value="Marketing">Marketing</option>
                    <option value="Reward">Reward</option>
                    <option value="Other">Other</option>
                </select>
            </div>
  `,
        focusConfirm: false,
        showCancelButton: true,
        preConfirm: () => {
            const amount = parseInt(document.getElementById("swal-amount").value);
            const reason = document.getElementById("swal-reason").value;
            if (!amount || amount <= 0) {
                Swal.showValidationMessage("Please enter a valid coin amount");
                return false;
            }
            if (!reason) {
                Swal.showValidationMessage("Please select a reason");
                return false;
            }
            return { amount, reason };
        },
    });

    if (!formValues) return;




    try {
        const { data } = await addCoinsAPI(userId, formValues);

        if (data.status === 1) {
            Swal.fire({
                icon: "success",
                title: "Coins Added",
                text: `Successfully added ${formValues.amount} coins. New balance: ${data.coins}`,
            });

            if (typeof onSuccess === "function") {
                onSuccess(data.coins);
            }
            await dispatch(fetchUserById({ id: userId, navigate }));


        } else {
            Swal.fire("Error", data.message || "Failed to add coins", "error");
        }
    } catch (err) {
        console.error(err);
        Swal.fire("Error", "Server error", "error");
    }
};
